import 'moment/locale/th'
import moment, { Moment } from 'moment'
import { sortBy } from 'lodash'
moment.locale('en')

export const createDate = () => moment().set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0).toDate()

export const resetTime = (date: string) =>
    moment(date).set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0).toDate()

export const convertDateToDateString = (date: Moment, format = 'YYYY-MM-DD') => {
    if (date) return moment(date).format(format)
}

export const convertDateToFormatTH = (date: string | Moment, format = 'DD MMM YYYY') => {
    moment.locale('th')
    let newDate = moment(date).add(543, 'year').format(format)

    // if (date) return moment(date).format(format)
    if (newDate) return newDate
    else return '-'
}
export const convertDateToFormatEN = (date: string | Moment, format = 'DD MMM YYYY') => {
    moment.locale('en')
    let newDate = moment(date).format(format)
    if (newDate) return newDate
    else return '-'
}

export const dateForAPI = (date?: string | Moment | null, withoutTime?: boolean) => {
    if (date) {
        if (withoutTime) {
            return moment(date).format('YYYY-MM-DD')
        }
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
}

export const formatDateToString = (date: string[]) => {
    const sortDate = sortBy(date, (item) => new Date(item))
    let dateData: string[][] = []
    let i = 0

    sortDate.forEach((item, index) => {
        if (index === 0) {
            dateData[i] = [item]
        } else {
            const diff = moment(sortDate[index]).diff(moment(sortDate[index - 1]), 'days')
            if (diff === 1) {
                dateData[i] = [...dateData[i], item]
            } else {
                const y = i + 1
                dateData[y] = [item]
                i++
            }
        }
    })

    const arrDate = dateData.map((item) => {
        if (item.length > 1) {
            return `${moment(item[0]).format('DD')}-${moment(item[item.length - 1])
                .add(543, 'year')
                .format('DD MMM YYYY')}`
        } else {
            return `${moment(item[0]).add(543, 'year').format('DD MMM YYYY')}`
        }
    })

    return arrDate.toString().replace(/,/g, ', ')
}

export const formatDateToString2 = (date: string[]) => {
    const sortedDate = date.sort()
    let dateMin = 0,
        dateCheck = parseInt(moment(sortedDate[0]).format('DD')), //เก็บวันที่ ณ ปัจจุบัน
        dateMax = 0,
        index = 0,
        dateStore: string[] = [],
        dateText = ''

    // เงื่อนไขถ้ามีการส่งวันที่เข้ามามากกว่า 1 วัน
    if (sortedDate.length > 1) {
        sortedDate.forEach((item, key) => {
            if (parseInt(moment(item).format('DD')) === dateCheck + 1) {
                dateCheck = parseInt(moment(item).format('DD'))
                dateMax = dateCheck
                if (key + 1 === sortedDate.length) {
                    if (dateMin !== 0) {
                        dateStore[index] = `${dateMin}-${dateMax} ${moment(sortedDate[0])
                            .add(543, 'year')
                            .format('MMM YYYY')}`
                        index++
                    } else {
                        dateStore[index] = `${dateCheck} ${moment(item).add(543, 'year').format('MMM YYYY')}`
                        index++
                    }
                }
            } else {
                if (key === 0) {
                    dateMin = parseInt(moment(item).format('DD'))
                    dateCheck = dateMin
                } else if (dateMax !== 0) {
                    dateStore[index] = `${dateMin}-${dateMax} ${moment(sortedDate[0])
                        .add(543, 'year')
                        .format('MMM YYYY')}`
                    index++
                    dateCheck = parseInt(moment(item).format('DD'))
                    dateMax = 0
                    dateMin = 0
                    if (key + 1 === sortedDate.length) {
                        dateStore[index] = `${dateCheck} ${moment(item).add(543, 'year').format('MMM YYYY')}`
                    }
                } else if (dateMax === 0) {
                    dateStore[index] = `${dateCheck} ${moment(item).add(543, 'year').format('MMM YYYY')}`
                    index++
                    dateMin = parseInt(moment(item).format('DD'))
                    dateCheck = dateMin
                }
            }
        })
        dateStore.forEach((item, key) => {
            dateText += `${item}`
            if (key + 1 !== dateStore.length) {
                dateText += `, `
            }
        })
        return { dateCancel: dateText }
    } else {
        date.forEach((item) => {
            const date = parseInt(moment(item).format('DD'))
            return { dateCancel: `${date} ${moment(item).add(543, 'year').format('MMM YYYY')}` }
        })
    }
}

export const addDays = (date: Date, days: number) => {
    let myDate = new Date(date)
    myDate.setDate(myDate.getDate() + days)
    return myDate
}
